import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SortOption } from 'src/app/core/models/filter.model';
import { FilterService } from 'src/app/core/services/filter.service';

@Component({
  selector: 'app-sort-content',
  templateUrl: './sort-content.component.html',
  styleUrls: ['./sort-content.component.scss',],
})
export class SortContentComponent implements OnInit {

  sortOptions: SortOption[] = [];

  @Output() applySortEvent = new EventEmitter<string>();

  constructor(
    private _router: Router,
    private _activateRoute: ActivatedRoute,
    private _filterService: FilterService
  ) { }

  ngOnInit(): void {
    this.getSortOptions();
  }

  getSortOptions() {
    this._filterService.getSortOptions().subscribe({
      next: (data: SortOption[]) => {
        this.sortOptions = data;
      },
    });
  }

  onSortChanged(selectedSort: SortOption) {
    const newParams = { ...this._activateRoute.snapshot.queryParams, };
    newParams['sortBy'] = selectedSort.key;
    newParams['orderBy'] = selectedSort.value;
    this._router.navigate([], { queryParams: newParams, });
    this.applySortEvent.emit(selectedSort.label);
  }


}
